import React from 'react';
import { Field } from 'redux-form';
import TextArea from '../../../content/components/TextArea';
import {
  WhiteLabelContentContainer
} from '../WLContentContainer/WhiteLabelContentContainer';

const LetterFooter = ({}) => {

  return (
    <>
      <WhiteLabelContentContainer title={'Letter Footer'}>
        <Field name="meta.whitelabel.letter_footer" component={TextArea}/>
      </WhiteLabelContentContainer>
    </>
  );
};
export default LetterFooter;
